var React = require('react');

function Percentage (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.25 6.048a5.205 5.205 0 0 0-5.202 5.202 5.216 5.216 0 0 0 5.202 5.202 5.216 5.216 0 0 0 5.202-5.202 5.216 5.216 0 0 0-5.202-5.202Zm0 7.722a2.497 2.497 0 0 1-2.502-2.502 2.497 2.497 0 0 1 2.502-2.502 2.497 2.497 0 0 1 2.502 2.502 2.497 2.497 0 0 1-2.502 2.502Zm13.5 5.778a5.205 5.205 0 0 0-5.202 5.202 5.216 5.216 0 0 0 5.202 5.202 5.216 5.216 0 0 0 5.202-5.202 5.216 5.216 0 0 0-5.202-5.202Zm0 7.722a2.497 2.497 0 0 1-2.502-2.502 2.497 2.497 0 0 1 2.502-2.502 2.497 2.497 0 0 1 2.502 2.502 2.497 2.497 0 0 1-2.502 2.502ZM8.424 29.448l-1.89-1.89L27.54 6.534l1.89 1.89L8.424 29.43v.018Z","fill":"#231D19"}));
}

Percentage.defaultProps = {"viewBox":"0 0 36 36","fill":"none","className":"icon"};

module.exports = Percentage;

Percentage.default = Percentage;
